import React from "react";
import { TextField as MuiTextField } from "@mui/material";

interface TextFieldProps {
  label: string;
  value: string;
  type?: React.HTMLInputTypeAttribute;
  onChange: (val: string) => void;
}

export default function TextField({
  label,
  value,
  type,
  onChange,
}: TextFieldProps) {
  return (
    <MuiTextField
      margin="dense"
      variant="outlined"
      label={label}
      type={type}
      value={value}
      onChange={(evt) => onChange(evt.target.value)}
    />
  );
}
